import WorkContainer from './WorkContainer';
export default WorkContainer;